<mat-card *ngIf="firmaDatasource">
    <mat-card-content>
        <table mat-table [dataSource]="firmaDatasource" class="mat-elevation-z1">
            <ng-container matColumnDef="firmenname">
                <th mat-header-cell *matHeaderCellDef> NAME </th>
                <td mat-cell *matCellDef="let element"> {{element.firmenname}} </td>
            </ng-container>
            <ng-container matColumnDef="firmenId">
                <th mat-header-cell *matHeaderCellDef> FIRMENID </th>
                <td mat-cell *matCellDef="let element"> {{element.firmenId}} </td>
            </ng-container>
            <ng-container matColumnDef="anschrift">
                <th mat-header-cell *matHeaderCellDef> ANSCHRIFT </th>
                <td mat-cell *matCellDef="let element"> {{element.strasseUndHausnummer }} | {{element.plz}} {{element.ort}} {{element.land}} </td>
            </ng-container>
            <ng-container matColumnDef="crefonummer">
                <th mat-header-cell *matHeaderCellDef> CREFONUMMER </th>
                <td mat-cell *matCellDef="let element"> {{element.crefonummer}} </td>
            </ng-container>
            <ng-container matColumnDef="beDirectId">
                <th mat-header-cell *matHeaderCellDef> BEDIRECT-ID </th>
                <td mat-cell *matCellDef="let element"> {{element.beDirectId}} </td>
            </ng-container>
                
            <tr mat-header-row *matHeaderRowDef="displayFirmaDataColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayFirmaDataColumns;"></tr>
        </table>
    </mat-card-content>
</mat-card>  

<mat-card *ngIf="firmaHistoryDatasource">
    <mat-card-content>
        <table mat-table multiTemplateDataRows [dataSource]="firmaHistoryDatasource" class="mat-elevation-z1">
            
            <ng-container matColumnDef="expand">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element" class="expand-button">
                    <button mat-icon-button color="primary"
                        (click)="toggleRowFirmaTransactions(element)">
                        <mat-icon class="mat-icon-rtl-mirror">
                            {{expandedFirmaTransaction === element ? 'remove' : 'add'}}
                        </mat-icon>
                    </button>
                </td>
            </ng-container>
            
            <ng-container matColumnDef="title">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element">
                {{element.title}}
                </td>
            </ng-container>

            <ng-container matColumnDef="expandedFirmaTransactions">
                <td mat-cell *matCellDef="let element" [attr.colspan]="displayColumnsTransactionWithAction.length">
                    <div class="element-firma-transaktionen" 
                        [@expandableRow]="expandedFirmaTransaction === element ? 'expanded' : 'collapsed'">
                        <div class="inner-table mat-elevation-z1" *ngIf="expandedFirmaTransaction === element">
                            <table #innerTablesFirmaTransactions mat-table multiTemplateDataRows [dataSource]="element.transactions">
                                
                                <ng-container matColumnDef="expand">
                                    <th mat-header-cell *matHeaderCellDef></th>
                                    <td mat-cell *matCellDef="let element">
                                        <button mat-icon-button color="primary"
                                            *ngIf="element.firmaHistoryEintraege.data.length > 0"
                                            (click)="toggleRowFirmaHistory(element)">
                                            <mat-icon class="mat-icon-rtl-mirror">
                                                {{expandedFirmaHistory === element ? 'remove' : 'add'}}
                                            </mat-icon>
                                        </button>
                                    </td>
                                </ng-container>
                                
                                <ng-container matColumnDef="datum">
                                    <th mat-header-cell *matHeaderCellDef> DATUM </th>
                                    <td mat-cell *matCellDef="let element"> {{element.datum | date:'dd.MM.yyyy'}} </td>
                                </ng-container>

                                <ng-container matColumnDef="uhrzeit">
                                    <th mat-header-cell *matHeaderCellDef> UHRZEIT </th>
                                    <td mat-cell *matCellDef="let element"> {{element.uhrzeit | date:'hh:mm:ss'}} </td>
                                </ng-container>

                                <ng-container matColumnDef="id">
                                    <th mat-header-cell *matHeaderCellDef> ID </th>
                                    <td mat-cell *matCellDef="let element"> {{element.id}} </td>
                                </ng-container>

                                <ng-container matColumnDef="user">
                                    <th mat-header-cell *matHeaderCellDef> USER </th>
                                    <td mat-cell *matCellDef="let element"> {{element.user}} </td>
                                </ng-container>

                                <ng-container matColumnDef="aktion">
                                    <th mat-header-cell *matHeaderCellDef> AKTION </th>
                                    <td mat-cell *matCellDef="let element" class="action-description"> {{element.aktion}} </td>
                                </ng-container>

                                <ng-container matColumnDef="kommentar">
                                    <th mat-header-cell *matHeaderCellDef> KOMMENTAR </th>
                                    <td mat-cell *matCellDef="let element" class="action-description"> {{element.kommentar}} </td>
                                </ng-container>

                                <ng-container matColumnDef="expandedFirmaHistory">
                                    <td mat-cell *matCellDef="let element" [attr.colspan]="initColumnsFirmaHistoryEintraege.length">
                                        <div class="element-firma-historie"
                                            [@expandableRow]="expandedFirmaHistory === element ? 'expanded' : 'collapsed'">
                                            <div class="inner-table mat-elevation-z1" *ngIf="expandedFirmaHistory === element">
                                                <table #innerTablesFirmaHistory mat-table [dataSource]="element.firmaHistoryEintraege">
                                                    <ng-container matColumnDef="{{innerColumn.name}}" *ngFor="let innerColumn of initColumnsFirmaHistoryEintraege">
                                                        <th mat-header-cell *matHeaderCellDef> {{innerColumn.label.toUpperCase()}} </th>
                                                        <td mat-cell *matCellDef="let element"> {{element[innerColumn.name]}} </td>
                                                    </ng-container>
                                                    <tr mat-header-row *matHeaderRowDef="displayColumnsFirmaHistoryEintraege"></tr>
                                                    <tr mat-row *matRowDef="let row; columns: displayColumnsFirmaHistoryEintraege;"></tr>
                                                </table>
                                            </div>
                                        </div>
                                    </td>
                                </ng-container>
                                
                                <tr mat-header-row *matHeaderRowDef="displayColumnsTransactionWithAction"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayColumnsTransactionWithAction;"
                                    [class.element-row]="row.firmaHistoryEintraege.data.length"
                                    [class.expanded-row]="expandedFirmaHistory === row"></tr>
                                <tr mat-row *matRowDef="let row; columns: ['expandedFirmaHistory'];" class="historie-row"></tr>
                            </table>
                        </div>
                    </div>
                </td>
            </ng-container>

            <tr mat-row *matRowDef="let row; columns: displayColumns;"
                [class.element-row]="row.transactions.data.length"
                [class.expanded-row]="expandedFirmaTransaction === row"></tr>
            <tr mat-row *matRowDef="let row; columns: ['expandedFirmaTransactions'];" class="transaktionen-row"></tr>
        </table>
    </mat-card-content>
</mat-card>

<mat-card *ngIf="firmenstandorteHistoryDatasource">
    <mat-card-content>
        <table mat-table multiTemplateDataRows [dataSource]="firmenstandorteHistoryDatasource" class="mat-elevation-z1">
            
            <ng-container matColumnDef="expand">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element" class="expand-button">
                    <button mat-icon-button color="primary"
                    (click)="loadFirmenstandorteHistory(element)">
                    <mat-icon class="mat-icon-rtl-mirror">
                        {{expandedFirmenstandortTransactions === element ? 'remove' : 'add'}}
                    </mat-icon>
                </button>
                </td>
            </ng-container>

            <ng-container matColumnDef="title">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element">
                {{element.title}}
                </td>
            </ng-container>

            <ng-container matColumnDef="expandedFirmenstandortTransactions">
                <td mat-cell *matCellDef="let element" [attr.colspan]="displayColumnsTransactionWithAction.length">
                    <div class="element-firmenstandort-transaktionen"
                        [@expandableRow]="element == expandedFirmenstandortTransactions ? 'expanded' : 'collapsed'">
                        <div class="inner-table mat-elevation-z1" *ngIf="element == expandedFirmenstandortTransactions">
                            <table #innerTableFirmenstandortTransactions mat-table multiTemplateDataRows [dataSource]="element.transactions">
                                
                                <ng-container matColumnDef="expand">
                                    <th mat-header-cell *matHeaderCellDef></th>
                                    <td mat-cell *matCellDef="let element">
                                        <button mat-icon-button color="primary"
                                            *ngIf="element.firmenstandortHistoryEintraege.data.length > 0"
                                            (click)="toggleRowFirmenstandortHistory(element)">
                                            <mat-icon class="mat-icon-rtl-mirror">
                                                {{element == expandedFirmenstandortHistory ? 'remove' : 'add'}}
                                            </mat-icon>
                                        </button>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="datum">
                                    <th mat-header-cell *matHeaderCellDef> DATUM </th>
                                    <td mat-cell *matCellDef="let element"> {{element.datum | date:'dd.MM.yyyy'}} </td>
                                </ng-container>

                                <ng-container matColumnDef="uhrzeit">
                                    <th mat-header-cell *matHeaderCellDef> UHRZEIT </th>
                                    <td mat-cell *matCellDef="let element"> {{element.uhrzeit | date:'hh:mm:ss'}} </td>
                                </ng-container>

                                <ng-container matColumnDef="id">
                                    <th mat-header-cell *matHeaderCellDef> ID </th>
                                    <td mat-cell *matCellDef="let element"> {{element.id}} </td>
                                </ng-container>

                                <ng-container matColumnDef="user">
                                    <th mat-header-cell *matHeaderCellDef> USER </th>
                                    <td mat-cell *matCellDef="let element"> {{element.user}} </td>
                                </ng-container>

                                <ng-container matColumnDef="aktion">
                                    <th mat-header-cell *matHeaderCellDef> AKTION </th>
                                    <td mat-cell *matCellDef="let element" class="action-description"> {{element.aktion}} </td>
                                </ng-container>

                                <ng-container matColumnDef="kommentar">
                                    <th mat-header-cell *matHeaderCellDef> KOMMENTAR </th>
                                    <td mat-cell *matCellDef="let element" class="action-description"> {{element.kommentar}} </td>
                                </ng-container>

                                <ng-container matColumnDef="expandedFirmenstandortHistory">
                                    <td mat-cell *matCellDef="let element" [attr.colspan]="initColumnsFirmenstandortHistoryEintraege.length">
                                        <div class="element-firmenstandort-historie"
                                            [@expandableRow]="element == expandedFirmenstandortHistory ? 'expanded' : 'collapsed'">
                                            <div class="inner-table mat-elevation-z1" *ngIf="element == expandedFirmenstandortHistory">
                                                <table #innerTablesFirmenstandortHistory mat-table [dataSource]="element.firmenstandortHistoryEintraege">
                                                    <ng-container matColumnDef="{{innerColumn.name}}" *ngFor="let innerColumn of initColumnsFirmenstandortHistoryEintraege">
                                                        <th mat-header-cell *matHeaderCellDef> {{innerColumn.label.toUpperCase()}} </th>
                                                        <td mat-cell *matCellDef="let element"> {{element[innerColumn.name]}} </td>
                                                    </ng-container>
                                                    <tr mat-header-row *matHeaderRowDef="displayColumnsFirmenstandortHistoryEintraege"></tr>
                                                    <tr mat-row *matRowDef="let row; columns: displayColumnsFirmenstandortHistoryEintraege;"></tr>
                                                </table>
                                            </div>
                                        </div>
                                    </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="displayColumnsTransactionWithAction"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayColumnsTransactionWithAction;"
                                    [class.element-row]="row.firmenstandortHistoryEintraege.data.length"
                                    [class.expanded-row]="expandedFirmenstandortHistory === row"></tr>
                                <tr mat-row *matRowDef="let row; columns: ['expandedFirmenstandortHistory'];" class="historie-row"></tr>
                            </table>
                        </div>
                    </div>
                </td>
            </ng-container>

            <tr mat-row *matRowDef="let row; columns: displayColumns;"
                [class.element-row]="row.transactions.data.length"
                [class.expanded-row]="expandedFirmenstandortTransactions === row"></tr>
            <tr mat-row *matRowDef="let row; columns: ['expandedFirmenstandortTransactions'];" class="transaktionen-row"></tr>
        </table>
    </mat-card-content>
</mat-card>

<mat-card *ngIf="pcAdressenHistoryTableDatasource">
    <mat-card-content>
        <table mat-table multiTemplateDataRows [dataSource]="pcAdressenHistoryTableDatasource" class="mat-elevation-z1">

            <ng-container matColumnDef="expand">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element" class="expand-button">
                    <button mat-icon-button color="primary"
                    (click)="loadPcAdressenHistory(element)">
                    <mat-icon class="mat-icon-rtl-mirror">
                        {{expandedPcAdresseTable === element ? 'remove' : 'add'}}
                    </mat-icon>
                </button>
                </td>
            </ng-container>

            <ng-container matColumnDef="title">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element">
                {{element.title}}
                </td>
            </ng-container>

            <ng-container matColumnDef="expandedPcAdresseTable">
                <td mat-cell *matCellDef="let element" [attr.colspan]="displayColumns.length">
                    <div [@expandableRow]="element == expandedPcAdresseTable ? 'expanded' : 'collapsed'">
                        <div class="inner-table mat-elevation-z1" *ngIf="element == expandedPcAdresseTable">

                            <table mat-table multiTemplateDataRows [dataSource]="element.tableElements" class="mat-elevation-z1">
            
                                <ng-container matColumnDef="expand">
                                    <th mat-header-cell *matHeaderCellDef></th>
                                    <td mat-cell *matCellDef="let element" class="expand-button">
                                        <button mat-icon-button color="primary"
                                        *ngIf="element.transactions?.data.length > 0"
                                        (click)="toggleRowPcAdresseTransaction(element)">
                                        <mat-icon class="mat-icon-rtl-mirror">
                                            {{expandedPcAdresseTransactions === element ? 'remove' : 'add'}}
                                        </mat-icon>
                                    </button>
                                    </td>
                                </ng-container>
        
                                <ng-container matColumnDef="title">
                                    <th mat-header-cell *matHeaderCellDef></th>
                                    <td mat-cell *matCellDef="let element">
                                    {{element.title}}
                                    </td>
                                </ng-container>
        
                                <ng-container matColumnDef="expandedPcAdresseTransactions">
                                    <td mat-cell *matCellDef="let element" [attr.colspan]="displayColumnsTransactionWithAction.length">
                                        <div class="element-pcadresse-transaktionen"
                                            [@expandableRow]="element == expandedPcAdresseTransactions ? 'expanded' : 'collapsed'">
                                            <div class="inner-table mat-elevation-z1" *ngIf="element == expandedPcAdresseTransactions">
                                                <table #innerTablePcAdresseTransactions mat-table multiTemplateDataRows [dataSource]="element.transactions">
                                                    
                                                    <ng-container matColumnDef="expand">
                                                        <th mat-header-cell *matHeaderCellDef></th>
                                                        <td mat-cell *matCellDef="let element">
                                                            <button mat-icon-button color="primary"
                                                                *ngIf="element.pcAdressenHistoryEintraege.data.length > 0"
                                                                (click)="toggleRowPcAdresseHistory(element)">
                                                                <mat-icon class="mat-icon-rtl-mirror">
                                                                    {{element == expandedPcAdresseHistory ? 'remove' : 'add'}}
                                                                </mat-icon>
                                                            </button>
                                                        </td>
                                                    </ng-container>
        
                                                    <ng-container matColumnDef="datum">
                                                        <th mat-header-cell *matHeaderCellDef> DATUM </th>
                                                        <td mat-cell *matCellDef="let element"> {{element.datum | date:'dd.MM.yyyy'}} </td>
                                                    </ng-container>
        
                                                    <ng-container matColumnDef="uhrzeit">
                                                        <th mat-header-cell *matHeaderCellDef> UHRZEIT </th>
                                                        <td mat-cell *matCellDef="let element"> {{element.uhrzeit | date:'hh:mm:ss'}} </td>
                                                    </ng-container>
        
                                                    <ng-container matColumnDef="id">
                                                        <th mat-header-cell *matHeaderCellDef> ID </th>
                                                        <td mat-cell *matCellDef="let element"> {{element.id}} </td>
                                                    </ng-container>
        
                                                    <ng-container matColumnDef="user">
                                                        <th mat-header-cell *matHeaderCellDef> USER </th>
                                                        <td mat-cell *matCellDef="let element"> {{element.user}} </td>
                                                    </ng-container>
        
                                                    <ng-container matColumnDef="aktion">
                                                        <th mat-header-cell *matHeaderCellDef> AKTION </th>
                                                        <td mat-cell *matCellDef="let element" class="action-description"> {{element.aktion}} </td>
                                                    </ng-container>

                                                    <ng-container matColumnDef="kommentar">
                                                        <th mat-header-cell *matHeaderCellDef> KOMMENTAR </th>
                                                        <td mat-cell *matCellDef="let element" class="action-description"> {{element.kommentar}} </td>
                                                    </ng-container>
        
                                                    <ng-container matColumnDef="expandedPcAdresseHistory">
                                                        <td mat-cell *matCellDef="let element" [attr.colspan]="initColumnsPcAdressenHistoryEintraege.length">
                                                            <div class="element-pcadresse-historie"
                                                                [@expandableRow]="element == expandedPcAdresseHistory ? 'expanded' : 'collapsed'">
                                                                <div class="inner-table mat-elevation-z1" *ngIf="element == expandedPcAdresseHistory">
                                                                    <table #innerTablesPcAdresseHistory mat-table [dataSource]="element.pcAdressenHistoryEintraege">
                                                                        <ng-container matColumnDef="{{innerColumn.name}}" *ngFor="let innerColumn of initColumnsPcAdressenHistoryEintraege">
                                                                            <th mat-header-cell *matHeaderCellDef> {{innerColumn.label.toUpperCase()}} </th>
                                                                            <td mat-cell *matCellDef="let element"> {{element[innerColumn.name]}} </td>
                                                                        </ng-container>
                                                                        <tr mat-header-row *matHeaderRowDef="displayColumnsPcAdressenHistoryEintraege"></tr>
                                                                        <tr mat-row *matRowDef="let row; columns: displayColumnsPcAdressenHistoryEintraege;"></tr>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </ng-container>
        
                                                    <tr mat-header-row *matHeaderRowDef="displayColumnsTransactionWithAction"></tr>
                                                    <tr mat-row *matRowDef="let row; columns: displayColumnsTransactionWithAction;"
                                                        [class.element-row]="row.pcAdressenHistoryEintraege?.data.length"
                                                        [class.expanded-row]="expandedPcAdresseHistory === row"></tr>
                                                    <tr mat-row *matRowDef="let row; columns: ['expandedPcAdresseHistory'];" class="historie-row"></tr>
                                                </table>
                                            </div>
                                        </div>
                                    </td>
                                </ng-container>
        
                                <tr mat-row *matRowDef="let row; columns: displayColumns;"
                                    [class.element-row]="row.transactions?.data.length"
                                    [class.expanded-row]="expandedPcAdresseTransactions === row"></tr>
                                <tr mat-row *matRowDef="let row; columns: ['expandedPcAdresseTransactions'];" class="transaktionen-row"></tr>
                            </table>
                            
                        </div>
                    </div>
                </td>
            </ng-container>

            <tr mat-row *matRowDef="let row; columns: displayColumns;"
                [class.element-row]="row.tableElements?.data.length"
                [class.expanded-row]="expandedPcAdresseTable === row"></tr>
            <tr mat-row *matRowDef="let row; columns: ['expandedPcAdresseTable'];" class="history-row"></tr>

        </table>
    </mat-card-content>
</mat-card>

<mat-card class="card-actions back">
    <mat-card-content>
        <button (click)="back()" class="btn btn-flat bg-gradient-secondary left">
            <i class="fas fa-arrow-left"></i> Zur&uuml;ck zur Firmenansicht
        </button>
    </mat-card-content>
</mat-card>
